export default __webpack_public_path__ + "static/media/HideDrawerLogo.db2dd45a.svg";